const {createBoolean,createObject, createString, traversePropertiesString, valueIf} = require('../../shared');

module.exports.basicSpouse = function (appData, formData, outData){

  if (!outData.error && !createObject(appData, "basic", {})) {
    outData.error = "Cannot create basic info";
  }

  if (!outData.error && !createString(appData.basic, "memberStatus", traversePropertiesString(formData,['basic','spcstatus']), true)) {
    outData.error = "Cannot set member status";
  }

  if (!outData.error && !createString(appData.basic, "firstName", traversePropertiesString(formData,['spouse','fname']), true)) {
    outData.error = "Cannot set member First Name";
  }

  if (!outData.error && !createString(appData.basic, "middleInitital", traversePropertiesString(formData,['spouse','middleInitial']))) {
    outData.error = "Cannot set member Middle Initial";
  }

  if (!outData.error && !createString(appData.basic, "lastName", traversePropertiesString(formData,['spouse','lname']), true)) {
    outData.error = "Cannot set member Last Name";
  }

  if (!outData.error && !createString(appData.basic, "gender", traversePropertiesString(formData,['spouse','gender']), true)) {
    outData.error = "Cannot set member Gender";
  }

  if (!outData.error && !createString(appData.basic, "relationshipStatus", traversePropertiesString(formData,['basic','relationshipStatus']), true)) {
    outData.error = "Cannot set member Birhdate";
  }

  if (!outData.error && !createString(appData.basic, "dateOfBirth", traversePropertiesString(formData,['spouse','bdate']), true)) {
    outData.error = "Cannot set member Birhdate";
  }

  if (!outData.error && !createBoolean(appData.basic, "tobaccoUse", traversePropertiesString(formData,['spouse','tobacco'])==="Y", true)) {
    outData.error = "Cannot set member SSN";
  }

  if (!outData.error && !createString(appData.basic, "currentStreet", valueIf(traversePropertiesString(formData,['spouse','currentUseNew'])==="1", traversePropertiesString(formData,['spouse','currentAddress']),traversePropertiesString(formData,['primary','currentAddress'])), true)) {
    outData.error = "Cannot set member currentStreet";
  }

  if (!outData.error && !createString(appData.basic, "currentZip", valueIf(traversePropertiesString(formData,['spouse','currentUseNew'])==="1", traversePropertiesString(formData,['spouse','currentZip']),traversePropertiesString(formData,['primary','currentZip'])), true)) {
    outData.error = "Cannot set member currentZip";
  }

  if (!outData.error && !createString(appData.basic, "permanentStreet", valueIf(traversePropertiesString(formData,['spouse','permanentUseNew'])==="1", traversePropertiesString(formData,['spouse','permanentAddress']),traversePropertiesString(appData,['basic','currentStreet'])), true)) {
    outData.error = "Cannot set member permanentStreet";
  }

  if (!outData.error && !createString(appData.basic, "permanentZip", valueIf(traversePropertiesString(formData,['spouse','permanentUseNew'])==="1", traversePropertiesString(formData,['spouse','permanentZip']),traversePropertiesString(appData,['basic','currentZip'])), true)) {
    outData.error = "Cannot set member permanentZip";
  }

  if (!outData.error && !createString(appData.basic, "phone", traversePropertiesString(formData,['spouse','phone']), true)) {
    outData.error = "Cannot set member phone";
  }

  if (!outData.error && !createString(appData.basic, "workPhone", traversePropertiesString(formData,['spouse','workPhone']), false)) {
    outData.error = "Cannot set member workPhone";
  }

  if (!outData.error && !createString(appData.basic, "email", traversePropertiesString(formData,['spouse','email']), true)) {
    outData.error = "Cannot set member email";
  }

}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/basicSpouse.js